<template>
  <div class="w-full h-full">
    <div class="homerBanner">

    </div>

    <div class="flex flex-col items-center justify-center m-auto w-full sm:w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] mb-8 sm:mb-12 md:mb-16 lg:mb-[68px] px-4 sm:px-6">
      <img
        src="../../assets/img/about.webp"
        alt="about"
        class="pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-6 sm:pb-8 md:pb-10 lg:pb-[46px] max-w-[100px] sm:max-w-[122px] md:max-w-[144px] scroll-fade-in"
      >
      <div class="text-[#333333] title-family-normal  sm:text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] text-center scroll-fade-in leading-relaxed">
        为深耕 LBE 大空间领域的科技先锋，我们聚焦 XR 技术落地与商业价值赋能，打造覆盖全场景的沉浸式解决方案矩阵。公司核心业务涵盖智能高效的XR 播控系统、颠覆感官体验的LBE 大空间沉浸式产品，以及革新行业生态的XR
        家装解决方案。我们以前沿科技为笔、以用户体验为墨，将虚拟与现实深度融合，为文旅、商业、家居等多元场景提供从技术研发到产品落地的全链条服务，致力于成为引领沉浸式商业变革的核心驱动力，让科技赋能生活，让创新点亮场景。</div>
    </div>
    <!-- 产品类型 -->
    <div class="productType bg-[#0C3D8E] pb-8 sm:pb-12 md:pb-16 lg:pb-[137px]">
      <div class="productTypeItem flex flex-col items-center justify-center px-4 sm:px-6">
        <img
          src="../../assets/img/product.webp"
          alt="productType1"
          class="pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-6 sm:pb-8 md:pb-10 lg:pb-[46px] max-w-[100px] sm:max-w-[122px] md:max-w-[144px]  scroll-fade-in"
        >
        <div class="text-[#fff] title-family-normal sm:text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] text-center pb-8 sm:pb-12 md:pb-16 lg:pb-[64px] px-4 scroll-fade-in leading-relaxed">
          全面适配主流MR智能眼镜终端，深度构建集高精度空间定位、多设备协同联动、全场景内容管控于一体的XR/MR大空间<br />播控系统，整合动态光影、全景声效、实时动作捕捉等核心技术，全方位打造可灵活适配文旅研学、商业娱乐、科普教育<br />等多元业态的沉浸式LBE智能大空间，为线下实体场景提供从技术支撑到内容落地的一体化解决方案。</div>
        <div class="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5 md:gap-[40px] w-full max-w-[1400px]">
          <div
            @click="router.push('/product.html')"
            class="flex flex-col items-center justify-center flex-wrap bg-white rounded-[16px] sm:rounded-[24px] lg:rounded-[32px] w-full sm:w-[90%] md:w-[48%] lg:w-[618px] h-auto min-h-[280px] sm:min-h-[300px] md:h-[332px] p-6 sm:p-8 md:p-10 transition-transform duration-300 ease-in-out hover:scale-105 sm:hover:scale-105 cursor-pointer scroll-fade-in"
          >
            <img
              src="../../assets/img/set.webp"
              alt="set"
              class="w-16 h-16 sm:w-20 sm:h-20 md:w-[100px] md:h-[100px] lg:w-[118px] lg:h-[118px] mb-6 sm:mb-8 md:mb-[70px]"
            >
            <div class="text-[#07409D] text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px] text-center font-bold px-2">
              XR大空间互动影片内容播控系统</div>
          </div>
          <div
            @click="router.push('/product/cyber.html')"
            class="flex flex-col items-center justify-center flex-wrap bg-white w-full sm:w-[90%] md:w-[48%] lg:w-[618px] h-auto min-h-[280px] sm:min-h-[300px] md:h-[332px] rounded-[16px] sm:rounded-[24px] lg:rounded-[32px] pt-8 sm:pt-10 md:pt-12 lg:pt-[56px] pb-6 sm:pb-8 md:pb-10 lg:pb-[52px] transition-transform duration-300 ease-in-out hover:scale-105 sm:hover:scale-105 cursor-pointer scroll-fade-in"
          >
            <img
              src="../../assets/img/set.webp"
              alt="set"
              class="w-16 h-16 sm:w-20 sm:h-20 md:w-[100px] md:h-[100px] lg:w-[118px] lg:h-[118px] mb-6 sm:mb-8 md:mb-[70px]"
            >
            <div class="text-[#07409D] text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px] text-center font-bold px-2">
              LBE VR大空间产品系列</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <SolutionSection />
    <!-- 服务案例 -->
    <div class="serviceCase bg-[#0C3D8E] w-full">
      <div class="serviceCaseItem flex flex-col items-center justify-center pb-8 sm:pb-12 md:pb-16 lg:pb-[137px] pt-8 sm:pt-12 md:pt-16 lg:pt-[68px]">
        <img
          src="../../assets/img/service.webp"
          alt="service"
          class="max-w-full h-auto pb-8 sm:pb-12 md:pb-16 lg:pb-[46px] scroll-fade-in"
        >
        <p class="text-white title-family-normal sm:text-[16px] md:text-[18px] lg:text-[24px] text-center max-w-[1200px] px-4 pb-[75px] scroll-fade-in">
          构建双核心 XR 大空间产品矩阵，精准覆盖运营管控与沉浸体验双重需求</p>

        <!-- 案例卡片 -->
        <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-[16px] flex-wrap px-4 max-w-[1500px] w-full">
          <div
            v-for="(item, index) in serviceCaseList"
            :key="index"
            class="relative w-full h-[280px] sm:h-[300px] md:h-[320px] lg:h-[340px] rounded-[16px] sm:rounded-[24px] lg:rounded-[32px] overflow-hidden cursor-pointer transition-transform duration-500 ease-out hover:scale-[1.03] hover:shadow-[0_0_24px_rgba(41,255,248,0.25)]"
            :class="index % 2 === 0 ? 'scroll-fade-in-left' : 'scroll-fade-in-right'"
            :style="{ transitionDelay: (index * 40) + 'ms' }"
            @click="goToCaseDetail(item.id)"
          >
            <!-- 背景图片 -->
            <img
              :src="item.image"
              :alt="item.title"
              class="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out hover:scale-105"
            >
            <!-- 下半部分透明遮罩层 -->
            <div class="absolute bottom-0 left-0 right-0 h-[40%] bg-gradient-to-t from-[#07409D] to-[#FFFFFF]/50"></div>
            <!-- 文字内容 -->
            <div class="absolute bottom-0 left-0 right-0 p-3 sm:p-4 pb-[12px] pl-6 flex flex-col">
              <div class="text-white text-[14px] sm:text-[16px] md:text-[18px] font-black mb-1 sm:mb-[4px] truncate">{{ item.title }}</div>
              <p class="text-white/90 title-family-12 text-[12px] sm:text-[13px] md:text-[14px] leading-relaxed mb-2 sm:mb-3 line-clamp-2">{{ item.description }}</p>
              <a
                @click.prevent="goToCaseDetail(item.id)"
                :href="item.link"
                class="text-[#29FFF8] font-normal sm:text-[13px] md:text-[14px] hover:opacity-80 transition-opacity self-start"
              >查看详情>>></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 服务客户 -->
    <div class="serviceCustomer bg-[#0B2456] w-full pb-8 sm:pb-12 md:pb-16 lg:pb-[96px] pt-8 sm:pt-12 md:pt-16 lg:pt-[68px]">
      <div class="flex flex-col items-center justify-center px-4 sm:px-6">
        <img
          src="../../assets/img/serviceCus.webp"
          alt="serviceCus"
          class="h-auto pb-8 sm:pb-12 md:pb-16 lg:pb-[76px] max-w-[100px] sm:max-w-[122px] md:max-w-[144px] scroll-fade-in"
        >
        <img
          src="../../assets/img/photo.webp"
          alt="photo"
          class="h-auto scroll-fade-in"
        >
      </div>
    </div>
    <!--  资讯中心 -->
    <div class="newsCenter bg-[#ffffff] w-full pb-8 sm:pb-12 md:pb-16 lg:pb-[100px] pt-8 sm:pt-12 md:pt-16 lg:pt-[68px]">
      <div class="newsCenterItem flex flex-col items-center justify-center px-4 sm:px-6">
        <img
          src="../../assets/img/information.webp"
          alt="information"
          class="h-auto pb-8 sm:pb-12 md:pb-16 lg:pb-[57px] max-w-[100px] sm:max-w-[122px] md:max-w-[144px] scroll-fade-in"
        >
        <!-- 案例卡片 -->
        <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-[16px] px-4 max-w-[1500px] w-full">
          <div
            v-for="(item, index) in newsList"
            :key="item.id || index"
            class="relative w-full h-[280px] sm:h-[300px] md:h-[320px] lg:h-[340px] rounded-[8px] overflow-hidden scroll-fade-in cursor-pointer"
            @click="goToNewsPageDetail(item.id)"
          >
            <!-- 背景图片 -->
            <img
              :src="item.image"
              :alt="item.title"
              class="absolute inset-0 w-full h-full object-cover"
            >
            <!-- 下半部分透明遮罩层 -->
            <div class="absolute bottom-0 left-0 right-0 h-[48%] bg-gradient-to-t from-[#07409D] to-[#FFFFFF]/50"></div>
            <!-- 文字内容 -->
            <div class="absolute bottom-0 left-0 right-0 p-3 sm:p-4 pb-[12px] pl-6 flex flex-col">
              <div class="text-white text-[14px] sm:text-[16px] md:text-[18px] font-black mb-[10px] sm:mb-[42px] truncate">{{ item.title }}</div>
              <p class="text-white/90 text-[12px] sm:text-[13px] md:text-[14px] leading-relaxed line-clamp-2">{{ item.description }}</p>
              <p class="text-white/90 text-[14px] titlefamily font-bold sm:text-[13px] md:text-[14px] leading-relaxed">{{ item.date }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <ContactUs />
  </div>
</template>

<script setup lang="ts">
import SolutionSection from "@/components/SolutionSection.vue";
import ContactUs from "@/components/ContactUs.vue";
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import xr1Img from "@/assets/img/xr-1.webp";
import { useRouter } from "vue-router";
import { newsApi, serviceApi } from "@/api";
import { RequestError } from "@/utils/request";

// 获取路由实例
const router = useRouter();

// 资讯列表数据接口
interface NewsItem {
  image: string;
  title: string;
  description: string;
  date: string;
  id: string;
}

// 服务案例数据接口
interface ServiceCaseItem {
  image: string;
  title: string;
  description: string;
  link: string;
  id: string;
}

// 资讯列表数据（接口获取）
const newsList = ref<NewsItem[]>([]);

const loadNewsList = async () => {
  try {
    const resp = await newsApi.getNewsList({ pageIndex: 1, pageSize: 3 });
    // ApiResponse<NewsListResponse> => { items, totalCount }
    const items = resp?.data?.items ?? [];
    newsList.value = items.slice(0, 3).map((n: any) => ({
      id: String(n.newsId ?? ""),
      title: n.title ?? "",
      description: n.desc ?? "",
      date: n.dateTime ?? "",
      image: n.image || xr1Img,
    }));

    // 数据更新后，重新观察动画元素（避免动态渲染的元素没被 observe）
    await nextTick();
    const elements = document.querySelectorAll(".scroll-fade-in");
    elements.forEach((el) => observer?.observe(el));
  } catch (e) {
    // 保底：接口失败时给 3 条占位，避免页面空白
    newsList.value = [
      {
        id: "0",
        image: xr1Img,
        title: "资讯加载失败",
        description: "请稍后重试",
        date: "",
      },
    ];
  }
};

// 服务案例列表数据（接口获取，默认取前 4 个）
const serviceCaseList = ref<ServiceCaseItem[]>([]);

type CaseRaw = {
  id: string;
  title: string;
  image: string;
  content: string;
  address: string;
};

const loadServiceCaseList = async () => {
  try {
    const res = await serviceApi.getCaseList();
    const list = (res.data || []) as CaseRaw[];
    serviceCaseList.value = list.slice(0, 4).map((item) => ({
      id: item.id,
      title: item.title ?? "",
      description: item.content ?? "",
      image: item.image || xr1Img,
      link: "#",
    }));

    await nextTick();
    // 重新观察新加载的服务案例卡片（包含左右飞入动画）
    const caseElements = document.querySelectorAll(
      ".scroll-fade-in-left, .scroll-fade-in-right"
    );
    caseElements.forEach((el) => {
      const element = el as HTMLElement;
      if (!animatedElements.has(element)) {
        // 检查元素是否已经在视口中
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
          // 如果元素已经在视口中，立即应用动画
          element.classList.add("fade-in-visible");
          animatedElements.add(element);
        } else if (observer) {
          // 否则开始观察
          observer.observe(element);
        }
      }
    });
  } catch (error) {
    console.error("加载服务案例失败:", error);
    if (error instanceof RequestError) {
      console.error("错误信息:", error.message);
    }
    serviceCaseList.value = [];
  }
};

// 存储已触发动画的元素
const animatedElements = new Set<HTMLElement>();

// Intersection Observer 配置
const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1, // 当元素10%可见时触发
};

// 创建 Intersection Observer
let observer: IntersectionObserver | null = null;

// 跳转到案例详情页
const goToCaseDetail = (id: string) => {
  if (!id) return;
  router.push(`/service/case/${id}.html`);
};

// 跳转到资讯详情页
const goToNewsPageDetail = (id: string) => {
  if (!id) return;
  router.push(`/news/${id}.html`);
};
onMounted(() => {
  // 创建 observer
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        !animatedElements.has(entry.target as HTMLElement)
      ) {
        // 元素进入视口且未触发过动画
        const element = entry.target as HTMLElement;
        element.classList.add("fade-in-visible");
        animatedElements.add(element);
      }
    });
  }, observerOptions);

  // 观察所有带有滚动动画类的元素
  const elements = document.querySelectorAll(
    ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
  );
  elements.forEach((element) => {
    if (observer) {
      observer.observe(element);
    }
  });

  // 加载资讯中心（一次请求三条）
  loadNewsList();

  // 加载服务案例（默认前 4 条）
  loadServiceCaseList();
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped lang="scss">
.titlefamily {
  font-family: "Noto Sans SC";
}
.title-family-16 {
  font-family: "Noto Sans SC";
  font-weight: black;
}
.title-family-12 {
  font-family: "Noto Sans SC";

  font-weight: normal;
}
.title-family-14 {
  font-family: "思源黑体CN";
  font-size: 14px;
  font-weight: normal;
}
.title-family-bold {
  font-family: "Noto Sans SC";
  font-weight: bold;
}

.title-family-normal {
  font-family: "Noto Sans SC";
  font-weight: normal;
}

.title-family-light {
  font-family: "Noto Sans SC";
  font-weight: light;
}
.homerBanner {
  width: 100%;
  height: clamp(156px, 41vw, 1200px);
  background-image: url("../../assets/img/banner1.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

// 滚动动画效果 - 小元素从底部飞入
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 滚动动画效果 - 从左边飞入 */
.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

/* 滚动动画效果 - 从右边飞入 */
.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}
</style>
